import axios from "axios";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { NotBanner, SimpleBannerContainer } from "../../styled/simpleTheme";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import { LuArrowRight } from "react-icons/lu";
import { useMediaQuery } from "react-responsive";

const SimpleBanner = () => {
  const navigate = useNavigate();
  const { cmpnyNo, url } = useOutletContext();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const [banner, setBanner] = useState([]);

  const location = useLocation();

  const isPath = () => {
    const basePath = `/shop/${url}`;
    return location.pathname === basePath || location.pathname === `${basePath}/`;
  };

  console.log(location);

  useEffect(() => {
    if (cmpnyNo) {
      getMyBanner(cmpnyNo);
    }
  }, [cmpnyNo, isMobile]);

  const getMyBanner = async (cmpnyNo) => {
    const url = "/api/firstSettingLoad";
    const body = {
      cmpnyNo,
      delYn: "N",
    };
    try {
      const res = await axios.post(url, body);

      const data = res.data;
      const images = JSON.parse(
        isMobile && data.mbannerImgList ? data.mbannerImgList : data.bannerImgList || "[]",
      );
      const text = JSON.parse(res.data.bannerImgTextList || "[]");

      if (images && images.length > 0) {
        setBanner(images.map((img, i) => ({ image: img, text: text[i] })));
      } else {
        const basePath = "/img/shop_main_bg";
        setBanner(
          [{ image: "/img/shopTheme/chic_bg_notice.png" }],
          // Array.from({ length: 3 }, (_, index) => ({ image: `${basePath}${index + 1}.jpg` })),
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  return isPath() ? (
    <SimpleBannerContainer className="banner">
      <Swiper
        className="banners"
        modules={[Navigation]}
        slidesPerView={1}
        loop={true}
        speed={2000}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}>
        {banner.map((item, i) => (
          <SwiperSlide key={i}>
            <div className="swiper-wrapper">
              <div className="bannerSlide" id={i}>
                <img src={`${imgHandler(item.image)}`} />
                {item.text && (
                  <div className="content">
                    <p>{item.text}</p>
                    <button onClick={() => navigate(`/shop/${url}/productsList`)}>
                      <span>자세히 보기</span>
                      <LuArrowRight />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </SimpleBannerContainer>
  ) : (
    <NotBanner></NotBanner>
  );
};

export default SimpleBanner;
